<app-section
  titleSection="Votre estimation"
  [isLargeTitle]="true"
  [isActivated]="appraisal.isEnabled"
  (enabled)="onEnabled($event)"
  (cancled)="onCancled()"
>
  <div read-mode class="px-3">
    <app-votre-estimation-read-mode
      [appraisal]="appraisalInternal"
      [reportType]="reportType"
    ></app-votre-estimation-read-mode>
  </div>

  <div edit-mode>
    <app-votre-estimation-edit-mode
      [appraisal]="appraisalInternal"
      (basicInfosChanged)="onBasicInfosChanged($event)"
      (redirectToReferences)="onRedirectToReferences()"
    ></app-votre-estimation-edit-mode>
  </div>

  <div save-button>
    <p-button
      id="btn-valider-section"
      label="Valider"
      level="primary"
      title="Valider"
      [loading]="isLoading"
      [disabled]="isLoading"
      (click)="onSaveSection()"
    ></p-button>
  </div>
</app-section>
